// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"river-max-portable-power-station_productcontent__foq71"};